<template>
    <div :id="id" class="row">
      <LmTextInput
        ref="inputFocus"
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="onLabelChange($event)"
        :label="$t('title')"
        :placeholder="$t('title')"
        :help="$t('comp_title_help')"
      />
      <LmTextInput
        v-if="validateSuperUser"
        class="col-12 col-md-4"
        :id="id + 'nombre'"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component)"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
      />
      <LmTextInput
        class="col-12 col-md-4"
        :id="id + 'placeholder'"
        v-model="component.componentProps.placeholder"
        @input="$emit('input', component)"
        :label="$t('placeholder')"
        :placeholder="$t('placeholder')"
        :help="$t('comp_placeholder_help')"
      />
      <LmTextInput
        class="col-12 col-md-4"
        :id="id + 'path-for-post-request'"
        v-model="component.componentProps.pathForPostRequest"
        @input="$emit('input', component)"
        :label="$t('comp_post_endpoint_setter')"
        :placeholder="$t('comp_post_endpoint_setter')"
        :help="$t('comp_post_endpoint_help')"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :id="String(id)"
        :leftValueToCompareOptions="leftValueToCompareOptions"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
        @input="$emit('input', component)"
        />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
      <!-- Componente para setear los permisos de usuario por campo del form -->
      <!-- <LmElementUserPermissionsUi
        :componentPermissions="component.componentPermissions"
      /> -->
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
// TODO: Si todo va ok, pasar al mixin
// import LmElementUserPermissionsUi from './LmElementUserPermissionsUi'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
    }
  },
  // components: {
  //   LmElementUserPermissionsUi
  // },
  watch: {
    // componentPermissions: {
    //   handler (val) {
    //     if (val) {
    //       this.component.componentPermissions = val
    //       this.$emit('input', this.component)
    //     }
    //   },
    //   deep: true
    // },
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
